'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = '',
        classList = this.compileStyle(_index2.default);

    if (this.props.label) {
        label = _react2.default.createElement(
            'div',
            { className: classList.label },
            this.props.label
        );
    } else if (this.props.children) {
        label = _react2.default.createElement(
            'div',
            { className: classList.label },
            this.props.children
        );
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        label,
        _react2.default.createElement(
            'div',
            { className: classList.wrapper },
            _react2.default.createElement('div', { className: classList.indeterminate })
        )
    );
}